import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import getAdUnits from './utils/getAdUnits';
var defaultLazyLoadConfig = {
  marginPercent: 0,
  mobileScaling: 1
};

var Advertising = /*#__PURE__*/function () {
  function Advertising(config) {
    var plugins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    _classCallCheck(this, Advertising);

    this.config = config;
    this.slots = {};
    this.outOfPageSlots = {};
    this.plugins = plugins;
    this.onError = onError;
    this.gptSizeMappings = {};
    this.customEventCallbacks = {};
    this.customEventHandlers = {};
    this.queue = [];
    this.setDefaultConfig();
  } // ---------- PUBLIC METHODS ----------


  _createClass(Advertising, [{
    key: "setup",
    value: function () {
      var _setup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var slots, outOfPageSlots, queue, isPrebidUsed, setUpQueueItems, _loop, i, divIds, selectedSlots;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.isPrebidUsed = typeof this.config.usePrebid === 'undefined' ? typeof window.pbjs !== 'undefined' : this.config.usePrebid;
                this.executePlugins('setup');
                slots = this.slots, outOfPageSlots = this.outOfPageSlots, queue = this.queue, isPrebidUsed = this.isPrebidUsed;
                this.setupCustomEvents();
                setUpQueueItems = [Advertising.queueForGPT(this.setupGpt.bind(this), this.onError)];

                if (isPrebidUsed) {
                  setUpQueueItems.push(Advertising.queueForPrebid(this.setupPrebid.bind(this), this.onError));
                }

                _context.next = 8;
                return Promise.all(setUpQueueItems);

              case 8:
                if (!(queue.length === 0)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                _loop = function _loop(i) {
                  var _queue$i = queue[i],
                      id = _queue$i.id,
                      customEventHandlers = _queue$i.customEventHandlers;
                  Object.keys(customEventHandlers).forEach(function (customEventId) {
                    if (!_this.customEventCallbacks[customEventId]) {
                      _this.customEventCallbacks[customEventId] = {};
                    }

                    return _this.customEventCallbacks[customEventId][id] = customEventHandlers[customEventId];
                  });
                };

                for (i = 0; i < queue.length; i++) {
                  _loop(i);
                }

                divIds = queue.map(function (_ref) {
                  var id = _ref.id;
                  return id;
                });
                selectedSlots = queue.map(function (_ref2) {
                  var id = _ref2.id;
                  return slots[id] || outOfPageSlots[id];
                });

                if (isPrebidUsed) {
                  Advertising.queueForPrebid(function () {
                    return window.pbjs.requestBids({
                      adUnitCodes: divIds,
                      bidsBackHandler: function bidsBackHandler() {
                        window.pbjs.setTargetingForGPTAsync(divIds);
                        Advertising.queueForGPT(function () {
                          return window.googletag.pubads().refresh(selectedSlots);
                        }, _this.onError);
                      }
                    });
                  }, this.onError);
                } else {
                  Advertising.queueForGPT(function () {
                    return window.googletag.pubads().refresh(selectedSlots);
                  }, this.onError);
                }

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setup() {
        return _setup.apply(this, arguments);
      }

      return setup;
    }() // async setupSlot(slotName) {
    //   //unused
    //   this.isPrebidUsed =
    //     typeof this.config.usePrebid === 'undefined'
    //       ? typeof window.pbjs !== 'undefined'
    //       : this.config.usePrebid;
    //   const { slots, outOfPageSlots, queue, isPrebidUsed } = this;
    //   this.setupCustomEvents();
    //   const setUpQueueItems = [
    //     Advertising.queueForGPT(this.defineSlot.bind(this, slotName), this.onError),
    //   ];
    //   if (isPrebidUsed) {
    //     setUpQueueItems.push(
    //       Advertising.queueForPrebid(this.setupPrebidSlot.bind(this, slotName), this.onError)
    //     );
    //   }
    //   await Promise.all(setUpQueueItems);
    //   if (queue.length === 0) {
    //     return;
    //   }
    //   console.log({ queue: queue })
    //   for (let i = 0; i < queue.length; i++) {
    //     const { id, customEventHandlers } = queue[i];
    //     Object.keys(customEventHandlers).forEach((customEventId) => {
    //       if (!this.customEventCallbacks[customEventId]) {
    //         this.customEventCallbacks[customEventId] = {};
    //       }
    //       return (this.customEventCallbacks[customEventId][id] =
    //         customEventHandlers[customEventId]);
    //     });
    //   }
    //   const divIds = queue.map(({ id }) => id);
    //   const selectedSlots = queue.map(
    //     ({ id }) => slots[id] || outOfPageSlots[id]
    //   );
    //   const labels = this.config.prebid?.sizeConfig?.map(config => config.labels[0]) || undefined;
    //   console.log({ selectedSlots })
    //   if (isPrebidUsed) {
    //     Advertising.queueForPrebid(
    //       () =>
    //         window.pbjs.requestBids({
    //           adUnitCodes: divIds,
    //           // labels: labels,
    //           bidsBackHandler: () => {
    //             window.pbjs.setTargetingForGPTAsync(divIds);
    //             Advertising.queueForGPT(
    //               () => window.googletag.pubads().refresh(selectedSlots),
    //               this.onError
    //             );
    //           },
    //         }),
    //       this.onError
    //     );
    //   } else {
    //     Advertising.queueForGPT(
    //       () => window.googletag.pubads().refresh(selectedSlots),
    //       this.onError
    //     );
    //   }
    // }

  }, {
    key: "teardown",
    value: function () {
      var _teardown = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var teardownQueueItems;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.teardownCustomEvents();
                teardownQueueItems = [Advertising.queueForGPT(this.teardownGpt.bind(this), this.onError)];

                if (this.isPrebidUsed) {
                  teardownQueueItems.push(Advertising.queueForPrebid(this.teardownPrebid.bind(this), this.onError));
                }

                _context2.next = 5;
                return Promise.all(teardownQueueItems);

              case 5:
                this.slots = {};
                this.gptSizeMappings = {};
                this.queue = [];

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function teardown() {
        return _teardown.apply(this, arguments);
      }

      return teardown;
    }() // async teardownSlot(slotName) {
    //   //TODO implement teardown custom events method for single ad slot
    //   const teardownQueueItems = [
    //     Advertising.queueForGPT(this.teardownGptSlot.bind(this, slotName), this.onError)
    //   ]
    //   if (this.isPrebidUsed) {
    //     teardownQueueItems.push(Advertising.queueForPrebid(this.teardownPrebidSlot.bind(this, slotName), this.onError))
    //   }
    //   await Promise.all(teardownQueueItems)
    //   delete this.slot[slotName]
    //   // const slotIndexToRemove = this.config.slots.findIndex(slot => slot.id === slotName)
    //   // console.log({ slotIndexToRemove })
    //   // if (slotIndexToRemove > -1) {
    //   //   this.slots.splice(slotIndexToRemove, 1);
    //   // }
    // }

  }, {
    key: "activate",
    value: function activate(id) {
      var _this2 = this;

      var customEventHandlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var slots = this.slots,
          isPrebidUsed = this.isPrebidUsed;

      if (Object.values(slots).length === 0) {
        this.queue.push({
          id: id,
          customEventHandlers: customEventHandlers
        });
        return;
      }

      Object.keys(customEventHandlers).forEach(function (customEventId) {
        if (!_this2.customEventCallbacks[customEventId]) {
          _this2.customEventCallbacks[customEventId] = {};
        }

        return _this2.customEventCallbacks[customEventId][id] = customEventHandlers[customEventId];
      });

      if (isPrebidUsed) {
        Advertising.queueForPrebid(function () {
          return window.pbjs.requestBids({
            adUnitCodes: [id],
            bidsBackHandler: function bidsBackHandler() {
              window.pbjs.setTargetingForGPTAsync([id]);
              Advertising.queueForGPT(function () {
                return window.googletag.pubads().refresh([slots[id]]);
              }, _this2.onError);
            }
          });
        }, this.onError);
      } else {
        Advertising.queueForGPT(function () {
          return window.googletag.pubads().refresh([slots[id]]);
        }, this.onError);
      }
    }
  }, {
    key: "isConfigReady",
    value: function isConfigReady() {
      return Boolean(this.config);
    }
  }, {
    key: "setConfig",
    value: function setConfig(config) {
      this.config = config;
      this.setDefaultConfig();
    } // ---------- PRIVATE METHODS ----------

  }, {
    key: "setupCustomEvents",
    value: function setupCustomEvents() {
      var _this3 = this;

      if (!this.config.customEvents) {
        return;
      }

      Object.keys(this.config.customEvents).forEach(function (customEventId) {
        return _this3.setupCustomEvent(customEventId, _this3.config.customEvents[customEventId]);
      });
    }
  }, {
    key: "setupCustomEvent",
    value: function setupCustomEvent(customEventId, _ref3) {
      var eventMessagePrefix = _ref3.eventMessagePrefix,
          divIdPrefix = _ref3.divIdPrefix;
      var customEventCallbacks = this.customEventCallbacks;

      this.customEventHandlers[customEventId] = function (_ref4) {
        var data = _ref4.data;

        if (typeof data !== 'string' || !data.startsWith("".concat(eventMessagePrefix))) {
          return;
        }

        var divId = "".concat(divIdPrefix || '').concat(data.substr(eventMessagePrefix.length));
        var callbacks = customEventCallbacks[customEventId];

        if (!callbacks) {
          return;
        }

        var callback = callbacks[divId];

        if (callback) {
          callback();
        }
      };

      window.addEventListener('message', this.customEventHandlers[customEventId]);
    }
  }, {
    key: "teardownCustomEvents",
    value: function teardownCustomEvents() {
      var _this4 = this;

      if (!this.config.customEvents) {
        return;
      }

      Object.keys(this.config.customEvents).forEach(function (customEventId) {
        return window.removeEventListener('message', _this4.customEventHandlers[customEventId]);
      });
    }
  }, {
    key: "defineGptSizeMappings",
    value: function defineGptSizeMappings() {
      if (!this.config.sizeMappings) {
        return;
      }

      var entries = Object.entries(this.config.sizeMappings);

      for (var i = 0; i < entries.length; i++) {
        var _entries$i = _slicedToArray(entries[i], 2),
            key = _entries$i[0],
            value = _entries$i[1];

        var sizeMapping = window.googletag.sizeMapping();

        for (var q = 0; q < value.length; q++) {
          var _value$q = value[q],
              viewPortSize = _value$q.viewPortSize,
              sizes = _value$q.sizes;
          sizeMapping.addSize(viewPortSize, sizes);
        }

        this.gptSizeMappings[key] = sizeMapping.build();
      }
    }
  }, {
    key: "getGptSizeMapping",
    value: function getGptSizeMapping(sizeMappingName) {
      return sizeMappingName && this.gptSizeMappings[sizeMappingName] ? this.gptSizeMappings[sizeMappingName] : null;
    }
  }, {
    key: "defineSlots",
    value: function defineSlots() {
      var _this5 = this;

      if (!this.config.slots) {
        return;
      }

      this.config.slots.forEach(function (_ref5) {
        var id = _ref5.id,
            path = _ref5.path,
            collapseEmptyDiv = _ref5.collapseEmptyDiv,
            _ref5$targeting = _ref5.targeting,
            targeting = _ref5$targeting === void 0 ? {} : _ref5$targeting,
            sizes = _ref5.sizes,
            sizeMappingName = _ref5.sizeMappingName;
        var slot = window.googletag.defineSlot(path || _this5.config.path, sizes, id);

        var sizeMapping = _this5.getGptSizeMapping(sizeMappingName);

        if (sizeMapping) {
          slot.defineSizeMapping(sizeMapping);
        }

        if (collapseEmptyDiv && collapseEmptyDiv.length && collapseEmptyDiv.length > 0) {
          slot.setCollapseEmptyDiv.apply(slot, _toConsumableArray(collapseEmptyDiv));
        }

        var entries = Object.entries(targeting);

        for (var i = 0; i < entries.length; i++) {
          var _entries$i2 = _slicedToArray(entries[i], 2),
              key = _entries$i2[0],
              value = _entries$i2[1];

          slot.setTargeting(key, value);
        }

        slot.addService(window.googletag.pubads());
        _this5.slots[id] = slot;
      });
    } // defineSlot(slotName) {
    //   if (!this.config.slots) {
    //     return;
    //   }
    //   console.log({ slotName })
    //   const slotToDefine = this.config.slots.find(slot => slot.id === slotName)
    //   console.log({ slotToDefine: typeof slotToDefine })
    //   if (typeof slotToDefine === "undefined") {
    //     return;
    //   }
    //   const { id,
    //     path,
    //     collapseEmptyDiv,
    //     targeting = {},
    //     sizes,
    //     sizeMappingName } = slotToDefine;
    //   const slot = window.googletag.defineSlot(
    //     path || this.config.path,
    //     sizes,
    //     id
    //   )
    //   const sizeMapping = this.getGptSizeMapping(sizeMappingName)
    //   if (sizeMapping) {
    //     slot.defineSizeMapping(sizeMapping);
    //   }
    //   if (
    //     collapseEmptyDiv &&
    //     collapseEmptyDiv.length &&
    //     collapseEmptyDiv.length > 0
    //   ) {
    //     slot.setCollapseEmptyDiv(...collapseEmptyDiv);
    //   }
    //   const entries = Object.entries(targeting);
    //   for (let i = 0; i < entries.length; i++) {
    //     const [key, value] = entries[i];
    //     slot.setTargeting(key, value);
    //   }
    //   slot.addService(window.googletag.pubads());
    //   googletag.pubads().enableSingleRequest();
    //   window.googletag.enableServices();
    //   this.slots[id] = slot;
    //   window.googletag.display(slotName)
    // }

  }, {
    key: "defineOutOfPageSlots",
    value: function defineOutOfPageSlots() {
      var _this6 = this;

      if (this.config.outOfPageSlots) {
        this.config.outOfPageSlots.forEach(function (_ref6) {
          var id = _ref6.id,
              path = _ref6.path;
          var slot = window.googletag.defineOutOfPageSlot(path || _this6.config.path, id);
          slot.addService(window.googletag.pubads());
          _this6.outOfPageSlots[id] = slot;
        });
      }
    }
  }, {
    key: "defineInterstitialSlot",
    value: function defineInterstitialSlot() {
      if (this.config.interstitialSlot) {
        var _this$config$intersti = this.config.interstitialSlot,
            path = _this$config$intersti.path,
            targeting = _this$config$intersti.targeting;
        var slot = window.googletag.defineOutOfPageSlot(path || this.config.path, window.googletag.enums.OutOfPageFormat.INTERSTITIAL);

        if (slot) {
          var entries = Object.entries(targeting || []);

          for (var i = 0; i < entries.length; i++) {
            var _entries$i3 = _slicedToArray(entries[i], 2),
                key = _entries$i3[0],
                value = _entries$i3[1];

            slot.setTargeting(key, value);
          }

          slot.addService(window.googletag.pubads());
          this.interstitialSlot = slot;
        }
      }
    }
  }, {
    key: "displaySlots",
    value: function displaySlots() {
      this.executePlugins('displaySlots');
      this.config.slots.forEach(function (_ref7) {
        var id = _ref7.id;
        window.googletag.display(id);
      });
    }
  }, {
    key: "displaySlot",
    value: function displaySlot(slotName) {
      window.googletag.cmd.push(function () {
        window.googletag.display(slotName);
      });
    }
  }, {
    key: "displayOutOfPageSlots",
    value: function displayOutOfPageSlots() {
      this.executePlugins('displayOutOfPageSlot');

      if (this.config.outOfPageSlots) {
        this.config.outOfPageSlots.forEach(function (_ref8) {
          var id = _ref8.id;
          window.googletag.display(id);
        });
      }
    }
  }, {
    key: "refreshInterstitialSlot",
    value: function refreshInterstitialSlot() {
      this.executePlugins('refreshInterstitialSlot');

      if (this.interstitialSlot) {
        window.googletag.pubads().refresh([this.interstitialSlot]);
      }
    }
  }, {
    key: "setupPrebid",
    value: function setupPrebid() {
      this.executePlugins('setupPrebid');
      var adUnits = getAdUnits(this.config.slots);
      window.pbjs.addAdUnits(adUnits);
      window.pbjs.setConfig(this.config.prebid);
    } // setupPrebidSlot(slotName) {
    //   const slotToAdd = this.config.slots.find(slot => slot.id === slotName)
    //   if (typeof slotToAdd === "undefined") {
    //     return;
    //   }
    //   const adUnit = getAdUnits([slotToAdd])
    //   window.pbjs.addAdUnits(adUnit)
    // }

  }, {
    key: "teardownPrebid",
    value: function teardownPrebid() {
      this.executePlugins('teardownPrebid');
      getAdUnits(this.config.slots).forEach(function (_ref9) {
        var code = _ref9.code;
        return window.pbjs.removeAdUnit(code);
      });
    } // teardownPrebidSlot(slotName) {
    //   this.executePlugins('teardownPrebid');
    //   const slotToRemove = this.config.slots.filter(slot => slot.id === slotName)
    //   const adUnit = getAdUnits(slotToRemove)
    //   window.pbjs.removeAdUnit(adUnit.code)
    // }

  }, {
    key: "setupGpt",
    value: function setupGpt() {
      this.executePlugins('setupGpt');
      var pubads = window.googletag.pubads();
      var targeting = this.config.targeting;
      this.defineGptSizeMappings();
      this.defineSlots();
      this.defineOutOfPageSlots();
      this.defineInterstitialSlot();
      var entries = Object.entries(targeting);

      for (var i = 0; i < entries.length; i++) {
        var _entries$i4 = _slicedToArray(entries[i], 2),
            key = _entries$i4[0],
            value = _entries$i4[1];

        pubads.setTargeting(key, value);
      }

      pubads.disableInitialLoad();
      pubads.enableSingleRequest();
      window.googletag.enableServices(); // this.displaySlots();

      this.displayOutOfPageSlots();
      this.refreshInterstitialSlot();
    }
  }, {
    key: "teardownGpt",
    value: function teardownGpt() {
      this.executePlugins('teardownGpt');
      window.googletag.destroySlots();
    } // teardownGptSlot(slotName) {
    //   this.executePlugins('teardownGpt')
    //   window.googletag.destroySlots([this.slots[slotName]])
    // }

  }, {
    key: "setDefaultConfig",
    value: function setDefaultConfig() {
      if (!this.config) {
        return;
      }

      if (!this.config.prebid) {
        this.config.prebid = {};
      }

      if (!this.config.metaData) {
        this.config.metaData = {};
      }

      if (!this.config.targeting) {
        this.config.targeting = {};
      }

      if (this.config.enableLazyLoad === true) {
        this.config.enableLazyLoad = defaultLazyLoadConfig;
      }

      if (this.config.slots) {
        this.config.slots = this.config.slots.map(function (slot) {
          return slot.enableLazyLoad === true ? _objectSpread(_objectSpread({}, slot), {}, {
            enableLazyLoad: defaultLazyLoadConfig
          }) : slot;
        });
      }
    }
  }, {
    key: "executePlugins",
    value: function executePlugins(method) {
      for (var i = 0; i < this.plugins.length; i++) {
        var func = this.plugins[i][method];

        if (func) {
          func.call(this);
        }
      }
    }
  }], [{
    key: "queueForGPT",
    value: function queueForGPT(func, onError) {
      return Advertising.withQueue(window.googletag.cmd, func, onError);
    }
  }, {
    key: "queueForPrebid",
    value: function queueForPrebid(func, onError) {
      return Advertising.withQueue(window.pbjs.que, func, onError);
    }
  }, {
    key: "withQueue",
    value: function withQueue(queue, func, onError) {
      return new Promise(function (resolve) {
        return queue.push(function () {
          try {
            func();
            resolve();
          } catch (error) {
            onError(error);
          }
        });
      });
    }
  }]);

  return Advertising;
}();

export { Advertising as default };